export const getDialogMessageConfig = (title, description) => ({
    className: "rj-reality-check-block",
    header: title,
    body: description,
    dataUat: "reality-check",
    actions: {}
});
//# sourceMappingURL=getDialogMessageConfig.js.map